import { PAGE_ERROR_TYPE, usePageError } from 'core/pageError';
import NotFoundErrorView from 'features/errors/NotFoundErrorView';
import UnhandledErrorView from 'features/errors/UnhandledErrorView';

const AppPage = ({ component: Component }) => {
  const { error } = usePageError();

  switch (error) {
    case PAGE_ERROR_TYPE.notFound:
      return <NotFoundErrorView />;

    case PAGE_ERROR_TYPE.unhandled:
      return <UnhandledErrorView />;

    default:
      return <Component />;
  }
};

export default AppPage;
